import { IRequirement } from '../../types/brand';
import { GET_REQUIREMENTS } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

const requirementsQueryKey = ['requirements'];

const getRequirements = async (): Promise<{
  success: boolean;
  data?: IRequirement[];
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(GET_REQUIREMENTS);
    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { getRequirements, requirementsQueryKey };